module.exports = __webpack_public_path__ + "static/media/actionresponse-days.75c5bb5c.svg";